import { FormattedDistance } from '../i18n';

import { getDistanceLabel, shouldRenderDistanceNode } from './get-distance';

import type { Distance as DistanceType } from '@shared/types/frontend/hotel-card';

type Props = {
  distance: DistanceType;
  isMobile?: boolean;
};

const Distance = ({
  distance: {
    cityName,
    distanceMeters,
    referenceEntityName,
    referenceEntityType,
  },
  isMobile,
}: Props) => {
  const { data, distancePlaceholder, label, options } = getDistanceLabel({
    referenceEntityName,
    referenceEntityType,
    isMobile,
  });

  if (shouldRenderDistanceNode(referenceEntityType)) {
    return (
      <FormattedDistance
        distanceMeters={distanceMeters}
        options={options}
        label={label}
        distancePlaceholder={distancePlaceholder}
        data={data}
      />
    );
  }

  return <>{cityName}</>;
};

export default Distance;
